// extracted by mini-css-extract-plugin
export default {"themeProvider":"Wkg231CS37_pdp","tokens":"Y7n8LsMG9L_pdp"};